import { put, call, takeEvery } from 'redux-saga/effects';
import { dtEntitySuccess, dtEntityFailure } from './actions';
import { DT_ENTITIES_REQUEST } from './actionTypes';
import DTEntitiesService from '../../services/DTEntitiesService';

export function* getDealerDTEntities(action) {
  try {
    const { dealerId } = action.payload;
    const result = yield call(DTEntitiesService.getDealerDTEntities, dealerId);
    yield put(dtEntitySuccess(result));
  } catch (error) {
    yield put(dtEntityFailure(error));
  }
}

export function* dtEntitiesSaga() {
  yield takeEvery(DT_ENTITIES_REQUEST, getDealerDTEntities);
}
